// Maps known backend response messages (returned in English) to i18n keys
// so they can be rendered in the user's active language.
//
// Match is by regex against the raw backend message so minor wording tweaks
// on the server (e.g. "attempt" → "attempts") don't immediately break the
// mapping. Add new entries here whenever you spot another English-only
// message in production.
//
// Patterns can include capture groups; the optional `values(match)` extractor
// turns them into i18n interpolation values that get forwarded to t(). Use
// {{name}} placeholders in the translated string to receive them.

const PATTERNS = [
  {
    test: /username or password incorrect.*5 failed login.*blocked for 24 hours/i,
    key: "backendMessages.loginFailed",
  },
  {
    test: /username already taken/i,
    key: "backendMessages.usernameAlreadyTaken",
  },
  {
    // Example: "login blocked, please wait 5 minutes until next login attempt or reset password!"
    test: /login blocked.*wait\s+(.+?)\s+until.+login attempt/i,
    key: "backendMessages.loginBlocked",
    values: (match) => ({ wait: match[1] }),
  },
  {
    // Example: "Sorry, we do not accept this type of email address (gmail.com)!"
    test: /we do not accept this type of email address\s*\(([^)]+)\)/i,
    key: "backendMessages.emailTypeRejected",
    values: (match) => ({ pattern: match[1] }),
  },
];

export function lookupBackendMessage(rawMessage) {
  if (!rawMessage || typeof rawMessage !== "string") return null;
  const hit = PATTERNS
    .map((p) => {
      const match = rawMessage.match(p.test);
      return match
        ? { key: p.key, values: p.values ? p.values(match) : undefined }
        : null;
    })
    .find((r) => r !== null);
  return hit || null;
}
